import React from "react";

export default function HtmlContent({content, ...props}) {
    return (
        <div dangerouslySetInnerHTML={{__html: content}} {...props} />
    );
}
